import { render, staticRenderFns } from "./curr.vue?vue&type=template&id=2907dc2d&"
import script from "./curr.vue?vue&type=script&lang=js&"
export * from "./curr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports